import styled from 'styled-components';
import tw from 'twin.macro';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';

const FooterContainer = styled.footer`
  ${tw`
    w-full
    bg-gray-900
    text-white
    pt-12
    pb-6
    border-t
    border-gray-800
    box-border
  `}
`;

const FooterContent = styled.div`
  ${tw`
    max-w-screen-xl
    mx-auto
    px-4
    grid
    grid-cols-1
    md:grid-cols-3
    gap-8
    box-border
  `}
`;

const FooterSection = styled.div`
  ${tw`
    flex
    flex-col
    box-border
  `}
`;

const SectionTitle = styled.h3`
  ${tw`
    text-lg
    font-bold
    mb-4
    text-white
    uppercase
    tracking-wider
  `}
`;

const LinkList = styled.ul`
  ${tw`
    space-y-2
    list-none
    p-0
  `}
`;

const FooterLink = styled(Link)`
  ${tw`
    text-gray-400
    transition-colors
    duration-200
    inline-block
  `}
  &:hover {
    ${tw`text-white`}
  }
`;

const ContactItem = styled.div`
  ${tw`
    flex
    items-start
    gap-3
    mb-3
    text-gray-400
  `}
`;

const IconWrapper = styled.div`
  ${tw`
    text-red-500
    mt-1
    flex-shrink-0
  `}
`;

const ContactText = styled.span`
  ${tw`
    text-left
  `}
`;

const Divider = styled.hr`
  ${tw`
    my-8
    border-gray-800
    w-full
    max-w-screen-xl
    mx-auto
  `}
`;

const BottomBar = styled.div`
  ${tw`
    max-w-screen-xl
    mx-auto
    px-4
    flex
    justify-center
    items-center
    text-gray-500
    text-sm
    box-border
  `}
`;

const AboutText = styled.p`
  ${tw`
    text-gray-400
    mb-4
  `}
`;

const LocationTitle = styled.h4`
  ${tw`
    font-semibold
    mb-2
    text-white
  `}
`;

const LocationContainer = styled.div`
  ${tw`
    mb-6
    last:mb-0
  `}
`;

const DealershipFooter = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <SectionTitle>LINKS</SectionTitle>
          <LinkList>
            <li>
              <FooterLink to="/">Home</FooterLink>
            </li>
            <li>
              <FooterLink to="/cars_on_sale/7e48ec1f-1e38-4d23-be8f-4bf21c9a6d4a">
                Inventory
              </FooterLink>
            </li>
            <li>
              <FooterLink to="/contact">Contact Us</FooterLink>
            </li>
            <li>
              <FooterLink to="/privacy">Privacy Policy</FooterLink>
            </li>
          </LinkList>
        </FooterSection>

        <FooterSection>
          <SectionTitle>ABOUT US</SectionTitle>
          <AboutText>
            Welcome to Jidosoju Holding Inc. (DBA: Autopilotee Cars) | Serving northern California.
            Start your next vehicle search at our dealership. See cars, trucks, and SUVs for sale at
            our location in San Jose, CA.
          </AboutText>
        </FooterSection>

        <FooterSection>
          <SectionTitle>CONTACT INFO</SectionTitle>
          <div>
            <LocationContainer>
              <LocationTitle>Jidosoju Holding Inc.</LocationTitle>
              <ContactText style={{ fontSize: '0.9rem', marginBottom: '8px', color: '#9CA3AF' }}>
                DBA: Autopilotee Cars
              </ContactText>
              <ContactItem>
                <IconWrapper>
                  <FontAwesomeIcon icon={faPhone} />
                </IconWrapper>
                <ContactText>+1(866)217-2849</ContactText>
              </ContactItem>
              <ContactItem>
                <IconWrapper>
                  <FontAwesomeIcon icon={faMapMarkerAlt} />
                </IconWrapper>
                <ContactText>2150 N. First Street, San Jose, CA 95131</ContactText>
              </ContactItem>
            </LocationContainer>
          </div>
        </FooterSection>
      </FooterContent>

      <Divider />

      <BottomBar>
        <p>Copyright © {new Date().getFullYear()}. All Rights Reserved</p>
      </BottomBar>
    </FooterContainer>
  );
};

export default DealershipFooter;
